import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '~/store/store';
import { getRelativeGetStore } from '~/store/utils';
import {
  State,
  SetCustomerPayload,
  Mla,
  SetIsSsnRequiredPayload,
  SetIsInputCustomerDetailsMismatchPayload,
} from './models';

const initialState: State = {
  customer: undefined,
  mlaStatus: Mla.Unknown,
  isSsnRequired: undefined,
  isLoggedIn: false,
  isFirstLogin: false,
  isInputCustomerDetailsMismatch: false,
};

export const customer = createSlice({
  name: 'customer',
  initialState: initialState,
  reducers: {
    setCustomer: (state, action: PayloadAction<SetCustomerPayload>) => {
      const {
        payload: { customer },
      } = action;

      state.customer = customer;
    },
    setIsSsnRequired: (state, action: PayloadAction<SetIsSsnRequiredPayload>) => {
      const {
        payload: { isSsnRequired },
      } = action;

      state.isSsnRequired = isSsnRequired;
    },
    setMlaStatus: (state, action: PayloadAction<{ mlaStatus: Mla }>) => {
      const {
        payload: { mlaStatus },
      } = action;
      state.mlaStatus = mlaStatus;
    },
    setIsLoggedIn: (state, action: PayloadAction<{ isLoggedIn: boolean }>) => {
      const {
        payload: { isLoggedIn },
      } = action;
      state.isLoggedIn = isLoggedIn;
    },
    setIsInputCustomerDetailsMismatch: (state, action: PayloadAction<SetIsInputCustomerDetailsMismatchPayload>) => {
      const {
        payload: { isInputCustomerDetailsMismatch },
      } = action;
      state.isInputCustomerDetailsMismatch = isInputCustomerDetailsMismatch;
    },
  },
});

export const getStore = getRelativeGetStore<Partial<State>>((store: RootState) => store.customer);

export const { setCustomer, setIsSsnRequired, setMlaStatus, setIsLoggedIn, setIsInputCustomerDetailsMismatch } =
  customer.actions;

export { Mla };

export default customer.reducer;
